import { createFileRoute } from "@tanstack/react-router";

import {
  guardDocumentAnalysisFeature,
  redirectToClientOverview,
} from "@/core/lib/feature-guards";

export const Route = createFileRoute(
  "/_protected/auditor/clients/$id/_client-tabs/document-analysis",
)({
  beforeLoad: ({ context: { active }, params }) => {
    if (!guardDocumentAnalysisFeature(active).allowed) {
      redirectToClientOverview(params.id);
    }
  },
});
